/**
 * Summary stats bar for the Voucher list page.
 * Stats reflect current filters (except status field).
 */
function VoucherSummaryBar({ stats = {} }) {
    const { total = 0, pending = 0, active = 0, taken = 0, out_of_stock = 0, expired = 0 } = stats;

    return (
        <div className="flex flex-wrap items-center gap-4 px-4 py-2 bg-surface rounded-lg border text-sm">
            <span className="text-content-3">
                Tổng: <strong className="text-content-2">{total.toLocaleString()}</strong>
            </span>
            <span className="text-orange-500 border-l pl-4">
                PENDING: <strong>{pending.toLocaleString()}</strong>
            </span>
            <span className="text-green-600 border-l pl-4">
                ACTIVE: <strong>{active.toLocaleString()}</strong>
            </span>
            <span className="text-blue-500 border-l pl-4">
                TAKEN: <strong>{taken.toLocaleString()}</strong>
            </span>
            <span className="text-red-400 border-l pl-4">
                OUT_OF_STOCK: <strong>{out_of_stock.toLocaleString()}</strong>
            </span>
            <span className="text-content-3 border-l pl-4">
                EXPIRED: <strong>{expired.toLocaleString()}</strong>
            </span>
        </div>
    );
}

export default VoucherSummaryBar;
